// import { getUnlocalizedPathname } from '@mcdougald/i18n';

export const DYNAMIC_FORMS_ROUTES = {
	formList: '/forms',
	createForm: '/forms/create',
	formDetail: '/forms/:id',
	formTemplates: '/forms/templates',
} as const;

export const PLATFORM_ROUTES = {
	homepage: '/',
	unauthorized: '/unauthorized',
	aboutMe: '/about-me',
	contactMe: '/contact-me',
	learnings: '/learnings',
	blog: '/blog',
	skills: '/skills',
	projects: '/projects',
	notFound: '/not-found',
} as const;

export const BLOG_ROUTES = {
	blog: '/blog',
	searchBlog: '/blog/list',
} as const;

export const AFFILIATE_ROUTES = {
	dashboard: '/affiliate',
	campaigns: '/affiliate/campaigns',
	campaignDetail: '/affiliate/campaigns/:id',
	campaignReport: '/affiliate/report',
	campaignReportDetail: '/affiliate/report/report-detail',
} as const;

export const AUTH_ROUTES = {
	login: '/login',
	signUp: '/signup',
	forgotPassword: '/forgot-password',
	forgotPasswordSuccess: '/forgot-password-success',
	setPassword: '/set-password',
	confirmInvitation: '/confirm-invitation',
	socialLogin: '/social-login',
} as const;

export const ADMIN_ROUTES = {
	dashboard: '/admin',
} as const;

export const PROTECTED_ROUTES = {
	admin: '/admin',
	creator: '/creator',
	learner: '/learner',
	blog: '/blog-admin',
	affiliate: '/affiliate',
	wallet: '/wallet',
} as const;

export const ZONE_ROUTES = {
	platform: '/',
	// admin: '/admin',
	blog: '/blog',
	// landing: '/landing',
} as const;

export const REFERRER_ROUTES = {
	admin: '/admin',
	creator: '/creator',
} as const;

export const WALLET_ROUTES = {
	wallet: '/wallet',
	deposit: '/wallet/deposit',
	withdraw: '/wallet/withdraw',
	history: '/wallet/history',
	depositHistory: '/wallet/deposit-history',
	withdrawHistory: '/wallet/withdraw-history',
	bankAccounts: '/wallet/bank-accounts',
	networks: '/wallet/networks',
	earning: '/wallet/earning',
	nft: '/wallet/nft',
	points: '/wallet/points',
} as const;

export const SITEMAP_ROUTES = [
	{
		path: PLATFORM_ROUTES.homepage,
		priority: 1,
		changeFrequency: 'daily' as const,
	},
	{
		path: PLATFORM_ROUTES.aboutMe,
		priority: 0.8,
		changeFrequency: 'daily' as const,
	},
	{
		path: PLATFORM_ROUTES.contactMe,
		priority: 0.8,
		changeFrequency: 'daily' as const,
	},
	{
		path: PLATFORM_ROUTES.learnings,
		priority: 0.8,
		changeFrequency: 'daily' as const,
	},
	{
		path: PLATFORM_ROUTES.blog,
		priority: 0.8,
		changeFrequency: 'daily' as const,
		isDynamic: true,
	},
	{
		path: PLATFORM_ROUTES.skills,
		priority: 0.8,
		changeFrequency: 'daily' as const,
	},
	{
		path: PLATFORM_ROUTES.projects,
		priority: 0.8,
		changeFrequency: 'daily' as const,
		isDynamic: true,
	},
];

// export function isProtectedRoute(pathname: string) {
//   const unlocalizedPathname = getUnlocalizedPathname(pathname);
//   return Object.entries(PROTECTED_ROUTES).some(([_, path]) => unlocalizedPathname.startsWith(path));
// }
//
// export function isZoneRoute(pathname: string, zone: IZoneRoutes) {
//   const unlocalizedPathname = getUnlocalizedPathname(pathname);
//   return Object.entries(ZONE_ROUTES).some(
//     ([zoneName, path]) => zoneName === zone && unlocalizedPathname.startsWith(path)
//   );
// }

export type IZoneRoutes = keyof typeof ZONE_ROUTES;
export type IZoneRoutesValues = (typeof ZONE_ROUTES)[IZoneRoutes];

export type IProtectedRoutes = keyof typeof PROTECTED_ROUTES;
export type IProtectedRoutesValues =
	(typeof PROTECTED_ROUTES)[IProtectedRoutes];

export type IReferrerRoutes = keyof typeof REFERRER_ROUTES;
